import { createRootRoute, Outlet } from "@tanstack/react-router";
import { useEffect } from "react";
import { initRuntimeCss } from "@/lib/runtimeCss";
import { preloadMonaco } from "@/lib/monaco-preloader";
import { sendReservedRoutes } from "@/lib/reservedRoutes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "@/components/auth/AuthProvider";
import { Toaster, toast } from "sonner";
import { CookieConsent } from "@/components/ui/cookie-consent";

const queryClient = new QueryClient();

export const Route = createRootRoute({
  component: () => (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RootComponent />
      </AuthProvider>
    </QueryClientProvider>
  ),
});

function RootComponent() {
  useEffect(() => {
    initRuntimeCss();
    // only preload monaco on editor routes to avoid loading ~5mb on landing
    try {
      const p = typeof window !== "undefined" ? window.location.pathname : "";
      if (p.startsWith("/editor")) {
        preloadMonaco();
      }
    } catch {
      // ignore
    }
    void sendReservedRoutes();

    // delay slightly to ensure toaster is mounted and any redirects settle
    const timer = setTimeout(() => {
      try {
        const url = new URL(window.location.href);
        if (url.searchParams.get("verified") === "1") {
          toast.success("email verified");
          url.searchParams.delete("verified");
          window.history.replaceState({}, "", url.toString());
        }
      } catch {
        // ignore error
      }
    }, 0);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Outlet />
      <Toaster position="top-center" richColors />
      <CookieConsent />
    </>
  );
}
